var gmw_plugin = ( function( $ ) {

	var maps = [];

	var _init = function() {
		_setup_readding_legend_after_map_loads();
	};

	var _setup_readding_legend_after_map_loads = function() {
		// Copied observeDOM function from: https://stackoverflow.com/questions/3219758/detect-changes-in-the-dom
		var observeDOM = ( function() {
			var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

			return function( obj, callback ) {
				if ( !obj || obj.nodeType !== 1 ) return;

				if ( MutationObserver ) {
					// define a new observer
					var mutationObserver = new MutationObserver( callback );

					// have the observer observe foo for changes in children
					mutationObserver.observe( obj, { childList: true, subtree: true } );
					return mutationObserver;
				}

				// browser support fallback
				else if ( window.addEventListener ) {
					obj.addEventListener( 'DOMNodeInserted', callback, false );
					obj.addEventListener( 'DOMNodeRemoved', callback, false );
				}
			}
		} )();

		// We have to use ES6 elements instead of jQuery to allow support for observeDOM
		var map            = document.querySelector( '.gmw-shortcode-widget' );
		var map_id_counter = 1;

		// Observe a specific DOM element:
		observeDOM( map, function( mutation_records ) {
			if ( map.classList && map.classList.contains( 'legend-updated' ) ) {
				return;
			}

			for ( var i = 0; i < mutation_records.length; i++ ) {
				var record = mutation_records[ i ];

				if ( record.addedNodes.length ) {
					// record.addedNodes.forEach(addedNode => {
					for ( var j = 0; j < record.addedNodes.length; j++ ) {
						var addedNode = record.addedNodes[ j ];

						// If we just got the gmw groups wrap (legend) element then save it to a maps array along with an ID for later
						if ( addedNode.classList && addedNode.classList.contains( 'gmw-groups-wrap' ) ) {
							var map_id = map_id_counter;
							map.setAttribute( 'crate-map-id', map_id );

							maps[ map_id ] = {
								map_id: map_id,
								node: map.cloneNode( true )
							};
							map_id++;

							addedNode.classList.add( 'hidden' );
						} else if ( map.getAttribute( 'crate-map-id' ) ) {
							// Otherwise this means we're getting the map data. Create timeouts to figure out when it finishes
							var map_id = map.getAttribute( 'crate-map-id' );

							if ( maps[ map_id ].timeout ) {
								clearTimeout( maps[ map_id ].timeout );
							}

							maps[ map_id ].timeout = setTimeout( function() {
								// Then once it finishes, add the previously stored HTML back into the map element,
								// and then add the legend updated class to stop it running again for this map
								map.classList.add( 'legend-updated' );
								var gmw_map_element = map.querySelector( '.gmw-map' );

								gmw_map_element.appendChild( maps[ map_id ].node );
							}, 100 );
						}
					}
				}
			}
		} );
	};

	if ( $( '.gmw-shortcode-widget' ).length ) {
		$( document ).ready( _init );
	}

	return {};

} )( jQuery );

module.exports = gmw_plugin;